"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercetoolsApi = void 0;
var axios_1 = __importDefault(require("axios"));
var qs_1 = __importDefault(require("qs"));
var __1 = require("../");
var error_1 = require("../error");
var constants_1 = require("../auth/constants");
var constants_2 = require("../constants");
var utils_1 = require("../utils");
/**
 * A collection of convenience methods for interacting with the
 * commercetools API.
 */
var CommercetoolsApi = /** @class */ (function () {
    function CommercetoolsApi(config) {
        this.config = config;
        this.auth = new __1.CommercetoolsAuth(config);
        this.endpoints = constants_1.REGION_URLS[this.config.region];
        this.userAgent = utils_1.buildUserAgent(this.config.systemIdentifier);
    }
    /**
     * Get a store given it's id
     * https://docs.commercetools.com/api/projects/stores#get-a-store-by-id
     */
    CommercetoolsApi.prototype.getStoreById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/stores/" + options.id, method: 'GET' }));
    };
    /**
     * Get a store given it's key
     * https://docs.commercetools.com/api/projects/stores#get-a-store-by-key
     */
    CommercetoolsApi.prototype.getStoreByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/stores/key=" + options.key, method: 'GET' }));
    };
    /**
     * Get an individual category by id:
     * https://docs.commercetools.com/api/projects/categories#get-category-by-id
     */
    CommercetoolsApi.prototype.getCategoryById = function (id, params) {
        if (params === void 0) { params = {}; }
        return this.request({
            path: "/categories/" + id,
            method: 'GET',
            params: params
        });
    };
    /**
     * Get an category by id or key. Either the id or the key must be provided.
     */
    CommercetoolsApi.prototype.getCategory = function (options) {
        if (!options.id && !options.key) {
            throw new error_1.CommercetoolsError('Either an id, key or slug must be provided');
        }
        if (options.id) {
            return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/categories/" + options.id, method: 'GET' }));
        }
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/categories/key=" + options.key, method: 'GET' }));
    };
    /**
     * Get a category projection by slug and locale
     */
    CommercetoolsApi.prototype.getCategoryBySlug = function (slug, languageCode, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request({
                            path: "/categories",
                            method: 'GET',
                            params: __assign(__assign({}, params), { where: "slug(" + languageCode + "=\"" + slug + "\")" })
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.count ? data.results[0] : null];
                }
            });
        });
    };
    /**
     * Query categories
     * https://docs.commercetools.com/api/projects/categories#query-categories
     */
    CommercetoolsApi.prototype.queryCategories = function (params) {
        if (params === void 0) { params = {}; }
        return this.request({
            path: "/categories",
            method: 'GET',
            params: params
        });
    };
    /**
     * Get the parent categories of a given category. This method returns an array
     * of {@see Category} items representing the ancestry of categories for the given
     * category id. The list is ordered from top down. In other words, the root
     * category is always the first item in the list.
     */
    CommercetoolsApi.prototype.getCategoryParents = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var category, ancestors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCategory(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { expand: 'ancestors[*]' }) }))];
                    case 1:
                        category = _a.sent();
                        ancestors = category.ancestors.map(function (ref) { return ref.obj; });
                        ancestors.push(__assign(__assign({}, category), { ancestors: category.ancestors.map(function (ancestor) { return ({ id: ancestor.id, typeId: ancestor.typeId }); }) }));
                        return [2 /*return*/, ancestors];
                }
            });
        });
    };
    /**
     * Get an individual product by id:
     * https://docs.commercetools.com/api/projects/products#get-product-by-id
     */
    CommercetoolsApi.prototype.getProductById = function (id, params) {
        if (params === void 0) { params = {}; }
        return this.request({
            path: "/products/" + id,
            method: 'GET',
            params: params
        });
    };
    /**
     * Get an individual product by key:
     * https://docs.commercetools.com/api/projects/products#get-product-by-key
     */
    CommercetoolsApi.prototype.getProductByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products/key=" + options.key, method: 'GET' }));
    };
    /**
     * Get a product projection by id
     * https://docs.commercetools.com/api/projects/productProjections#get-productprojection-by-id
     */
    CommercetoolsApi.prototype.getProductProjectionById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/product-projections/" + options.id, method: 'GET' }));
    };
    /**
     * Get a product projection by key
     * https://docs.commercetools.com/api/projects/productProjections#get-productprojection-by-key
     */
    CommercetoolsApi.prototype.getProductProjectionByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/product-projections/key=" + options.key, method: 'GET' }));
    };
    /**
     * Get a product projection by slug and locale
     */
    CommercetoolsApi.prototype.getProductProjectionBySlug = function (slug, languageCode, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request({
                            path: "/product-projections",
                            method: 'GET',
                            params: __assign(__assign({}, params), { where: "slug(" + languageCode + "=\"" + slug + "\")" })
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.count ? data.results[0] : null];
                }
            });
        });
    };
    /**
     * Query product projections
     * https://docs.commercetools.com/api/projects/productProjections#query-productprojections
     */
    CommercetoolsApi.prototype.queryProductProjections = function (params) {
        if (params === void 0) { params = {}; }
        return this.request({
            path: "/product-projections",
            method: 'GET',
            params: params
        });
    };
    /**
     * Search product projections
     * https://docs.commercetools.com/api/projects/products-search#search-productprojections
     */
    CommercetoolsApi.prototype.searchProductProjections = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/product-projections/search", method: 'GET' }));
    };
    /**
     * Get a cart by id
     * https://docs.commercetools.com/api/projects/carts#update-a-cart-by-id
     */
    CommercetoolsApi.prototype.getCartById = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/carts/" + options.id, options.storeKey), method: 'GET' }))];
            });
        });
    };
    /**
     * Create a new cart:
     * https://docs.commercetools.com/api/projects/carts#create-a-cart-1
     */
    CommercetoolsApi.prototype.createCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/carts", options.storeKey), method: 'POST', data: options.data }))];
            });
        });
    };
    /**
     * Update a cart by id
     * https://docs.commercetools.com/api/projects/carts#update-a-cart-by-id
     */
    CommercetoolsApi.prototype.updateCartById = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/carts/" + options.id, options.storeKey), method: 'POST', data: {
                            version: options.version,
                            actions: options.actions
                        } }))];
            });
        });
    };
    /**
     * Get the active cart. Requires a logged in or anonymous customer access token:
     * https://docs.commercetools.com/api/projects/me-carts#get-active-cart
     */
    CommercetoolsApi.prototype.getMyActiveCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/active-cart", options.storeKey), method: 'GET', accessToken: options.accessToken }))];
            });
        });
    };
    /**
     * Create a new cart for the customer associated with the given `accessToken` parameter:
     * https://docs.commercetools.com/api/projects/me-carts#create-a-cart-1
     */
    CommercetoolsApi.prototype.createMyCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/carts", options.storeKey), method: 'POST', data: options.data, accessToken: options.accessToken }))];
            });
        });
    };
    /**
     * Delete the active cart This method uses {@see getMyActiveCart} to first
     * get the active cart, in order to find the cart id and version:
     * https://docs.commercetools.com/api/projects/me-carts#delete-a-cart
     */
    CommercetoolsApi.prototype.deleteMyActiveCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyActiveCart(options)];
                    case 1:
                        cart = _a.sent();
                        return [4 /*yield*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/carts/" + cart.id, options.storeKey), method: 'DELETE', params: __assign(__assign({}, options.params), { version: cart.version }), accessToken: options.accessToken }))];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a customer's cart with the given actions. Note that we automatically
     * retrieve the customer's active cart using the given access token:
     * https://docs.commercetools.com/api/projects/me-carts#update-cart
     * https://docs.commercetools.com/api/projects/me-carts#update-actions
     */
    CommercetoolsApi.prototype.updateMyActiveCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyActiveCart(options)];
                    case 1:
                        cart = _a.sent();
                        return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/carts/" + cart.id, options.storeKey), method: 'POST', data: {
                                    version: cart.version,
                                    actions: options.actions
                                }, accessToken: options.accessToken }))];
                }
            });
        });
    };
    /**
     * Create an order from the given cart id. The cart id and version are automatically
     * retrieved by looking up the customers active cart:
     * https://docs.commercetools.com/api/projects/me-orders#create-order-from-a-cart
     */
    CommercetoolsApi.prototype.createMyOrderFromActiveCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyActiveCart(options)];
                    case 1:
                        cart = _a.sent();
                        return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore('/me/orders', options.storeKey), method: 'POST', data: {
                                    version: cart.version,
                                    id: cart.id
                                }, accessToken: options.accessToken }))];
                }
            });
        });
    };
    /**
     * Delete a cart by the given id:
     * https://docs.commercetools.com/api/projects/carts#delete-a-cart-by-id
     */
    CommercetoolsApi.prototype.deleteCartById = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/carts/" + options.id, options.storeKey), method: 'DELETE', params: __assign(__assign({}, options.params), { version: options.version }) }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a payment object using the customer's access token:
     * https://docs.commercetools.com/api/projects/me-payments#create-mypayment
     */
    CommercetoolsApi.prototype.createMyPayment = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: '/me/payments', method: 'POST', data: options.data, accessToken: options.accessToken }));
    };
    /**
     * Get an order by id using the customer's access token:
     * https://docs.commercetools.com/api/projects/me-orders#get-order-by-id
     */
    CommercetoolsApi.prototype.getMyOrderById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/orders/" + options.id, options.storeKey), method: 'GET', accessToken: options.accessToken }));
    };
    /**
     * Update an order by id:
     * https://docs.commercetools.com/api/projects/orders#update-order-by-id
     */
    CommercetoolsApi.prototype.updateOrderById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/orders/" + options.id, options.storeKey), method: 'POST', data: options.data }));
    };
    /**
     * Get an order by id:
     * https://docs.commercetools.com/api/projects/orders#get-order-by-id
     */
    CommercetoolsApi.prototype.getOrderById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/orders/" + options.id, options.storeKey), method: 'GET' }));
    };
    /**
     * Get an order by order number:
     * https://docs.commercetools.com/api/projects/orders#get-order-by-ordernumber
     */
    CommercetoolsApi.prototype.getOrderByOrderNumber = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/orders/order-number=" + options.orderNumber, method: 'GET' }));
    };
    /**
     * Delete an order by id:
     * https://docs.commercetools.com/api/projects/orders#delete-order-by-id
     */
    CommercetoolsApi.prototype.deleteOrderById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/orders/" + options.id, options.storeKey), method: 'DELETE', params: __assign(__assign({}, options.params), { version: options.version, dataErasure: options.dataErasure }) }));
    };
    /**
     * Delete an order by order number:
     * https://docs.commercetools.com/api/projects/orders#delete-order-by-ordernumber
     */
    CommercetoolsApi.prototype.deleteOrderByOrderNumber = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/orders/order-number=" + options.orderNo, options.storeKey), method: 'DELETE', params: __assign(__assign({}, options.params), { version: options.version, dataErasure: options.dataErasure }) }));
    };
    /**
     * Query orders:
     * https://docs.commercetools.com/api/projects/orders#query-orders-1
     */
    CommercetoolsApi.prototype.queryOrders = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/orders", options.storeKey), method: 'GET' }));
    };
    /**
     * Create a product:
     * https://docs.commercetools.com/api/projects/products#create-a-product
     */
    CommercetoolsApi.prototype.createProduct = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products", method: 'POST', data: options.data }));
    };
    /**
     * Update a product by key:
     * https://docs.commercetools.com/api/projects/products#update-product-by-key
     */
    CommercetoolsApi.prototype.updateProductByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products/key=" + options.key, method: 'POST', data: options.data }));
    };
    /**
     * Update a product by id:
     * https://docs.commercetools.com/api/projects/products#update-product-by-id
     */
    CommercetoolsApi.prototype.updateProductById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products/" + options.id, method: 'POST', data: options.data }));
    };
    /**
     * Delete a product by id:
     * https://docs.commercetools.com/api/projects/products#delete-product-by-id
     *
     * @param {object} options Request options
     * @param {boolean} options.unpublish If true, the product will be unpublished before being deleted
     */
    CommercetoolsApi.prototype.deleteProductById = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var version, product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        version = options.version;
                        if (!options.unpublish) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.unpublishProductById({
                                id: options.id,
                                version: options.version
                            })];
                    case 1:
                        product = _a.sent();
                        version = product.version;
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products/" + options.id, method: 'DELETE', params: __assign(__assign({}, options.params), { version: version }) }))];
                }
            });
        });
    };
    /**
     * Delete a product by key:
     * https://docs.commercetools.com/api/projects/products#delete-product-by-key
     *
     * @param {object} options Request options
     * @param {boolean} options.unpublish If true, the product will be unpublished before being deleted
     */
    CommercetoolsApi.prototype.deleteProductByKey = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var version, product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        version = options.version;
                        if (!options.unpublish) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.unpublishProductByKey({
                                key: options.key,
                                version: options.version
                            })];
                    case 1:
                        product = _a.sent();
                        version = product.version;
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products/key=" + options.key, method: 'DELETE', params: __assign(__assign({}, options.params), { version: version }) }))];
                }
            });
        });
    };
    /**
     * Unpublish a product by key
     *
     * Issues an 'unpublish' action for the given product:
     * https://docs.commercetools.com/api/projects/products#unpublish
     */
    CommercetoolsApi.prototype.unpublishProductByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products/key=" + options.key, method: 'POST', params: options.params, data: {
                version: options.version,
                actions: [{ action: 'unpublish' }]
            } }));
    };
    /**
     * Unpublish a product by id
     *
     * Issues an 'unpublish' action for the given product:
     * https://docs.commercetools.com/api/projects/products#unpublish
     */
    CommercetoolsApi.prototype.unpublishProductById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/products/" + options.id, method: 'POST', params: options.params, data: {
                version: options.version,
                actions: [{ action: 'unpublish' }]
            } }));
    };
    /**
     * Create a category:
     * https://docs.commercetools.com/api/projects/categories#create-a-category
     */
    CommercetoolsApi.prototype.createCategory = function (options) {
        return this.request({
            path: "/categories",
            method: 'POST',
            data: options.data
        });
    };
    /**
     * Update a category by key:
     * https://docs.commercetools.com/api/projects/categories#update-category-by-key
     */
    CommercetoolsApi.prototype.updateCategoryByKey = function (options) {
        return this.request({
            path: "/categories/key=" + options.key,
            method: 'POST',
            data: options.data
        });
    };
    /**
     * Update a category by id:
     * https://docs.commercetools.com/api/projects/categories#update-category-by-id
     */
    CommercetoolsApi.prototype.updateCategoryById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/categories/" + options.id, method: 'POST', data: options.data }));
    };
    /**
     * Delete a category by id:
     * https://docs.commercetools.com/api/projects/categories#delete-category-by-id
     */
    CommercetoolsApi.prototype.deleteCategoryById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/categories/" + options.id, method: 'DELETE', params: __assign(__assign({}, options.params), { version: options.version }) }));
    };
    /**
     * Delete a category by key:
     * https://docs.commercetools.com/api/projects/categories#delete-category-by-key
     */
    CommercetoolsApi.prototype.deleteCategoryByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/categories/key=" + options.key, method: 'DELETE', params: __assign(__assign({}, options.params), { version: options.version }) }));
    };
    /**
     * Create a customer account:
     * https://docs.commercetools.com/api/projects/customers#create-customer-sign-up
     */
    CommercetoolsApi.prototype.createAccount = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers", options.storeKey), method: 'POST', data: options.data }));
    };
    /**
     * Delete a customer account by id
     * https://docs.commercetools.com/api/projects/customers#delete-customer-by-id
     */
    CommercetoolsApi.prototype.deleteCustomerById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers/" + options.id, options.storeKey), method: 'DELETE', params: __assign(__assign({}, options.params), { version: options.version, dataErasure: options.dataErasure }) }));
    };
    /**
     * Delete a customer account by key
     * https://docs.commercetools.com/api/projects/customers#delete-customer-by-key
     */
    CommercetoolsApi.prototype.deleteCustomerByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers/key=" + options.key, options.storeKey), method: 'DELETE', params: __assign(__assign({}, options.params), { version: options.version, dataErasure: options.dataErasure }) }));
    };
    /**
     * Create a customer account given an anonymous access token:
     * https://docs.commercetools.com/api/projects/me-profile#create-customer-sign-up
     */
    CommercetoolsApi.prototype.createMyAccount = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/signup", options.storeKey), method: 'POST', data: options.data, accessToken: options.accessToken }));
    };
    /**
     * Login to customer's account:
     * https://docs.commercetools.com/api/projects/customers#authenticate-customer-sign-in
     */
    CommercetoolsApi.prototype.login = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/login", options.storeKey), method: 'POST', data: options.data }));
    };
    /**
     * Get a customer's account/profile:
     * https://docs.commercetools.com/api/projects/me-profile#get-customer
     */
    CommercetoolsApi.prototype.getMyAccount = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me", options.storeKey), method: 'GET', accessToken: options.accessToken }));
    };
    /**
     * Update a customer's account/profile:
     * https://docs.commercetools.com/api/projects/me-profile#update-customer
     */
    CommercetoolsApi.prototype.updateMyAccount = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me", options.storeKey), method: 'POST', accessToken: options.accessToken, data: options.data }));
    };
    /**
     * Change the customer's password:
     * https://docs.commercetools.com/api/projects/me-profile#change-customers-password
     */
    CommercetoolsApi.prototype.changeMyPassword = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/password", options.storeKey), method: 'POST', accessToken: options.accessToken, data: options.data }));
    };
    /**
     * Reset the customer's password:
     * https://docs.commercetools.com/api/projects/me-profile#reset-customers-password
     */
    CommercetoolsApi.prototype.resetMyPassword = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/me/password/reset", options.storeKey), method: 'POST', accessToken: options.accessToken, data: options.data }));
    };
    /**
     * Get a password reset token
     * https://docs.commercetools.com/api/projects/customers#create-a-token-for-resetting-the-customers-password
     */
    CommercetoolsApi.prototype.getPasswordResetToken = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers/password-token", options.storeKey), method: 'POST', data: options.data }));
    };
    /**
     * Get a customer by id:
     * https://docs.commercetools.com/api/projects/customers#get-customer-by-id
     */
    CommercetoolsApi.prototype.getCustomerById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers/" + options.id, options.storeKey), method: 'GET' }));
    };
    /**
     * Get a customer by key:
     * https://docs.commercetools.com/api/projects/customers#get-customer-by-key
     */
    CommercetoolsApi.prototype.getCustomerByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers/key=" + options.key, options.storeKey), method: 'GET' }));
    };
    /**
     * Get a customer by password token:
     * https://docs.commercetools.com/api/projects/customers#get-customer-by-password-token
     */
    CommercetoolsApi.prototype.getCustomerByPasswordToken = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers/password-token=" + options.token, options.storeKey), method: 'GET' }));
    };
    /**
     * Query customers:
     * https://docs.commercetools.com/api/projects/customers#query-customers
     */
    CommercetoolsApi.prototype.queryCustomers = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: this.applyStore("/customers", options.storeKey), method: 'GET' }));
    };
    /**
     * Get a product type by id:
     * https://docs.commercetools.com/api/projects/productTypes#get-a-producttype-by-id
     */
    CommercetoolsApi.prototype.getProductTypeById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/product-types/" + options.id, method: 'GET' }));
    };
    /**
     * Get a product type by key:
     * https://docs.commercetools.com/api/projects/productTypes#get-a-producttype-by-key
     */
    CommercetoolsApi.prototype.getProductTypeByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/product-types/key=" + options.key, method: 'GET' }));
    };
    /**
     * Get a type by id:
     * https://docs.commercetools.com/api/projects/types#get-type-by-id
     */
    CommercetoolsApi.prototype.getTypeById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/types/" + options.id, method: 'GET' }));
    };
    /**
     * Get a type by key:
     * https://docs.commercetools.com/api/projects/types#get-type-by-key
     */
    CommercetoolsApi.prototype.getTypeByKey = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/types/key=" + options.key, method: 'GET' }));
    };
    /**
     * Get a custom object
     * https://docs.commercetools.com/api/projects/custom-objects#get-customobject-by-container-and-key
     */
    CommercetoolsApi.prototype.getCustomObject = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/custom-objects/" + options.container + "/" + options.key, method: 'GET' }));
    };
    /**
     * Get a custom object by id
     * https://docs.commercetools.com/api/projects/custom-objects#get-customobject
     */
    CommercetoolsApi.prototype.getCustomObjectById = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/custom-objects/" + options.id, method: 'GET' }));
    };
    /**
     * Save a custom object
     * https://docs.commercetools.com/api/projects/custom-objects#create-or-update-a-customobject
     */
    CommercetoolsApi.prototype.saveCustomObject = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/custom-objects", method: 'POST', data: options.data }));
    };
    /**
     * Delete a custom object
     * https://docs.commercetools.com/api/projects/custom-objects#delete-customobject-by-container-and-key
     */
    CommercetoolsApi.prototype.deleteCustomObject = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/custom-objects/" + options.container + "/" + options.key, method: 'DELETE' }));
    };
    /**
     * Execute a GraphQL statement:
     * https://docs.commercetools.com/api/graphql
     */
    CommercetoolsApi.prototype.graphql = function (options) {
        return this.request(__assign(__assign({}, this.extractCommonRequestOptions(options)), { path: "/graphql", method: 'POST', data: options.data, accessToken: options.accessToken }));
    };
    /**
     * Make the request to the commercetools REST API.
     */
    CommercetoolsApi.prototype.request = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, url, opts, grant, headers, response, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        accessToken = options.accessToken;
                        url = this.endpoints.api + "/" + this.config.projectKey + options.path;
                        opts = __assign({}, options);
                        opts.path && delete opts.path;
                        opts.accessToken && delete opts.accessToken;
                        if (!!accessToken) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.auth.getClientGrant()];
                    case 1:
                        grant = _b.sent();
                        accessToken = grant.accessToken;
                        _b.label = 2;
                    case 2:
                        headers = __assign({ Authorization: "Bearer " + accessToken }, opts.headers);
                        if ((_a = process === null || process === void 0 ? void 0 : process.release) === null || _a === void 0 ? void 0 : _a.name) {
                            headers['User-Agent'] = this.userAgent;
                        }
                        if (typeof options.correlationId === 'string' && options.correlationId !== '') {
                            headers['X-Correlation-ID'] = options.correlationId;
                            delete options.correlationId;
                        }
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, axios_1.default(__assign(__assign({}, opts), { url: url,
                                headers: headers, timeout: this.config.timeoutMs || constants_2.DEFAULT_REQUEST_TIMEOUT_MS, paramsSerializer: function (params) {
                                    return qs_1.default.stringify(params, { arrayFormat: 'repeat' });
                                } }))];
                    case 4:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                    case 5:
                        error_2 = _b.sent();
                        if (error_2.isAxiosError) {
                            throw error_1.CommercetoolsError.fromAxiosError(error_2);
                        }
                        throw error_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Type-guard against any additional unexpected properties being passed in.
     */
    CommercetoolsApi.prototype.extractCommonRequestOptions = function (options) {
        return {
            correlationId: options.correlationId,
            params: options.params
        };
    };
    /**
     * Applies the store key to a given path
     */
    CommercetoolsApi.prototype.applyStore = function (path, storeKey) {
        if (typeof storeKey === 'string' && storeKey !== '') {
            return "/in-store/key=" + storeKey + path;
        }
        else if (this.config.storeKey) {
            return "/in-store/key=" + this.config.storeKey + path;
        }
        return path;
    };
    return CommercetoolsApi;
}());
exports.CommercetoolsApi = CommercetoolsApi;
//# sourceMappingURL=CommercetoolsApi.js.map